define('helperLayout-scrollTop',[],function() {

    var scrollTop = function() {
        var inFrame = (function() { try { return window.self !== window.top; } catch (e) { return true; } })(),
            scrollTo = function(node) {
                if (!node) {
                    return;
                }

                window.requestAnimFrame(function() {
                    node.scrollTop = 0;

                    if (!inFrame) {
                        node.scrollIntoView(true);
                    }
                });
            };

        window.requestAnimFrame(function() {
            scrollTo(document.body);
            scrollTo(document.documentElement);
            scrollTo(document.getElementById('content'));
        });
    };

    return scrollTop;
});

